import { RedocRawOptions } from 'redoc'
import { theme } from '@carbon/shared'

export const redocRawOptions = (version: string): RedocRawOptions => {
  return {
    theme: {
      logo: {
        gutter: '20px',
      },

      colors: {
        primary: {
          main: theme.palette.primary.main,
        },

        text: {
          primary: theme.palette.text.primary,
          secondary: theme.palette.primary.main,
        },
      },

      typography: {
        fontSize: '16px',
        fontWeightBold: '700',
        fontWeightRegular: '400',
        fontWeightLight: '400',
        headings: {
          lineHeight: theme.typography.h1?.lineHeight?.toString(),
          fontWeight: theme.typography.h1?.fontWeight?.toString(),
          fontFamily: theme.typography.fontFamily,
        },
        fontFamily: theme.typography.fontFamily,
        code: {
          fontFamily:
            'Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", Monaco, "Courier New", Courier, monospace;',
        },
      },

      sidebar: {
        backgroundColor: version === 'v1' ? theme.palette.primary.light : theme.palette.primary.main,
      },
    },
  }
}
